import React from "react";
import Box from "@mui/material/Box";

type ReticleProps = {
  size?: number;
  className?: string;
};

export default function Reticle({
  size = 190,
  className = "folder-reticle",
}: ReticleProps) {
  return (
    <Box
      className={className}
      aria-hidden
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: size,
        height: size,
        opacity: 0,
        pointerEvents: "none",
        transition: "opacity 0.15s ease",
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 72 72"
        sx={{
          width: "100%",
          height: "100%",
          display: "block",
          animation: "reticle-spin 1s linear infinite",
          "@keyframes reticle-spin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
        }}
      >
        <circle
          cx="36"
          cy="36"
          r="34"
          fill="none"
          stroke="rgba(20,20,20,0.8)"
          strokeWidth="2"
        />
        <circle
          cx="36"
          cy="36"
          r="20"
          fill="none"
          stroke="rgba(20,20,20,0.8)"
          strokeWidth="2"
        />
        <line
          x1="36"
          y1="0"
          x2="36"
          y2="72"
          stroke="rgba(20,20,20,0.8)"
          strokeWidth="2"
        />
        <line
          x1="0"
          y1="36"
          x2="72"
          y2="36"
          stroke="rgba(20,20,20,0.8)"
          strokeWidth="2"
        />
      </Box>
    </Box>
  );
}

